/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Advisor } from './Advisor';
import {
    AdvisorFromJSON,
    AdvisorFromJSONTyped,
    AdvisorToJSON,
} from './Advisor';
import type { CourseExperience } from './CourseExperience';
import {
    CourseExperienceFromJSON,
    CourseExperienceFromJSONTyped,
    CourseExperienceToJSON,
} from './CourseExperience';
import type { EducationExperience } from './EducationExperience';
import {
    EducationExperienceFromJSON,
    EducationExperienceFromJSONTyped,
    EducationExperienceToJSON,
} from './EducationExperience';
import type { ExternalLink } from './ExternalLink';
import {
    ExternalLinkFromJSON,
    ExternalLinkFromJSONTyped,
    ExternalLinkToJSON,
} from './ExternalLink';
import type { Item } from './Item';
import {
    ItemFromJSON,
    ItemFromJSONTyped,
    ItemToJSON,
} from './Item';
import type { ManagementExperienceText } from './ManagementExperienceText';
import {
    ManagementExperienceTextFromJSON,
    ManagementExperienceTextFromJSONTyped,
    ManagementExperienceTextToJSON,
} from './ManagementExperienceText';
import type { MobilityType } from './MobilityType';
import {
    MobilityTypeFromJSON,
    MobilityTypeFromJSONTyped,
    MobilityTypeToJSON,
} from './MobilityType';
import type { PersonalCompetenceItemSimple } from './PersonalCompetenceItemSimple';
import {
    PersonalCompetenceItemSimpleFromJSON,
    PersonalCompetenceItemSimpleFromJSONTyped,
    PersonalCompetenceItemSimpleToJSON,
} from './PersonalCompetenceItemSimple';
import type { SelectedItem } from './SelectedItem';
import {
    SelectedItemFromJSON,
    SelectedItemFromJSONTyped,
    SelectedItemToJSON,
} from './SelectedItem';
import type { SimpleTextResult } from './SimpleTextResult';
import {
    SimpleTextResultFromJSON,
    SimpleTextResultFromJSONTyped,
    SimpleTextResultToJSON,
} from './SimpleTextResult';
import type { VolunteerExperience } from './VolunteerExperience';
import {
    VolunteerExperienceFromJSON,
    VolunteerExperienceFromJSONTyped,
    VolunteerExperienceToJSON,
} from './VolunteerExperience';
import type { WorkExperience } from './WorkExperience';
import {
    WorkExperienceFromJSON,
    WorkExperienceFromJSONTyped,
    WorkExperienceToJSON,
} from './WorkExperience';

/**
 * 
 * @export
 * @interface PublicProfile
 */
export interface PublicProfile {
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    linkedin?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PublicProfile
     */
    showImage?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    resume?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    header?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    personalProfile?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    educationLevelText?: string;
    /**
     * 
     * @type {Array<ExternalLink>}
     * @memberof PublicProfile
     */
    externalLinks?: Array<ExternalLink>;
    /**
     * 
     * @type {Array<SimpleTextResult>}
     * @memberof PublicProfile
     */
    competences?: Array<SimpleTextResult>;
    /**
     * 
     * @type {Array<PersonalCompetenceItemSimple>}
     * @memberof PublicProfile
     */
    personalCompetences?: Array<PersonalCompetenceItemSimple>;
    /**
     * 
     * @type {Array<SimpleTextResult>}
     * @memberof PublicProfile
     */
    jobGoals?: Array<SimpleTextResult>;
    /**
     * 
     * @type {Array<SimpleTextResult>}
     * @memberof PublicProfile
     */
    jobFunctions?: Array<SimpleTextResult>;
    /**
     * 
     * @type {MobilityType}
     * @memberof PublicProfile
     */
    mobility?: MobilityType;
    /**
     * 
     * @type {Array<SelectedItem>}
     * @memberof PublicProfile
     */
    languages?: Array<SelectedItem>;
    /**
     * 
     * @type {Array<SelectedItem>}
     * @memberof PublicProfile
     */
    itCompetences?: Array<SelectedItem>;
    /**
     * 
     * @type {Array<Item>}
     * @memberof PublicProfile
     */
    driverLicenses?: Array<Item>;
    /**
     * 
     * @type {ManagementExperienceText}
     * @memberof PublicProfile
     */
    managementExperience?: ManagementExperienceText;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    mobile?: string;
    /**
     * 
     * @type {Advisor}
     * @memberof PublicProfile
     */
    advisor?: Advisor;
    /**
     * 
     * @type {boolean}
     * @memberof PublicProfile
     */
    showImageNetwork?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicProfile
     */
    jobProfilePublicState?: boolean;
    /**
     * 
     * @type {Array<SimpleTextResult>}
     * @memberof PublicProfile
     */
    jobTypes?: Array<SimpleTextResult>;
    /**
     * 
     * @type {Array<WorkExperience>}
     * @memberof PublicProfile
     */
    workExperience?: Array<WorkExperience>;
    /**
     * 
     * @type {Array<EducationExperience>}
     * @memberof PublicProfile
     */
    education?: Array<EducationExperience>;
    /**
     * 
     * @type {Array<CourseExperience>}
     * @memberof PublicProfile
     */
    courses?: Array<CourseExperience>;
    /**
     * 
     * @type {Array<VolunteerExperience>}
     * @memberof PublicProfile
     */
    volunteerExperience?: Array<VolunteerExperience>;
}

/**
 * Check if a given object implements the PublicProfile interface.
 */
export function instanceOfPublicProfile(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PublicProfileFromJSON(json: any): PublicProfile {
    return PublicProfileFromJSONTyped(json, false);
}

export function PublicProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'Email') ? undefined : json['Email'],
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'zip': !exists(json, 'Zip') ? undefined : json['Zip'],
        'city': !exists(json, 'City') ? undefined : json['City'],
        'country': !exists(json, 'Country') ? undefined : json['Country'],
        'linkedin': !exists(json, 'Linkedin') ? undefined : json['Linkedin'],
        'showImage': !exists(json, 'showImage') ? undefined : json['showImage'],
        'resume': !exists(json, 'Resume') ? undefined : json['Resume'],
        'header': !exists(json, 'Header') ? undefined : json['Header'],
        'personalProfile': !exists(json, 'PersonalProfile') ? undefined : json['PersonalProfile'],
        'educationLevelText': !exists(json, 'educationLevelText') ? undefined : json['educationLevelText'],
        'externalLinks': !exists(json, 'ExternalLinks') ? undefined : ((json['ExternalLinks'] as Array<any>).map(ExternalLinkFromJSON)),
        'competences': !exists(json, 'Competences') ? undefined : ((json['Competences'] as Array<any>).map(SimpleTextResultFromJSON)),
        'personalCompetences': !exists(json, 'personalCompetences') ? undefined : ((json['personalCompetences'] as Array<any>).map(PersonalCompetenceItemSimpleFromJSON)),
        'jobGoals': !exists(json, 'JobGoals') ? undefined : ((json['JobGoals'] as Array<any>).map(SimpleTextResultFromJSON)),
        'jobFunctions': !exists(json, 'JobFunctions') ? undefined : ((json['JobFunctions'] as Array<any>).map(SimpleTextResultFromJSON)),
        'mobility': !exists(json, 'Mobility') ? undefined : MobilityTypeFromJSON(json['Mobility']),
        'languages': !exists(json, 'Languages') ? undefined : ((json['Languages'] as Array<any>).map(SelectedItemFromJSON)),
        'itCompetences': !exists(json, 'ItCompetences') ? undefined : ((json['ItCompetences'] as Array<any>).map(SelectedItemFromJSON)),
        'driverLicenses': !exists(json, 'DriverLicenses') ? undefined : ((json['DriverLicenses'] as Array<any>).map(ItemFromJSON)),
        'managementExperience': !exists(json, 'managementExperience') ? undefined : ManagementExperienceTextFromJSON(json['managementExperience']),
        'phone': !exists(json, 'Phone') ? undefined : json['Phone'],
        'mobile': !exists(json, 'Mobile') ? undefined : json['Mobile'],
        'advisor': !exists(json, 'Advisor') ? undefined : AdvisorFromJSON(json['Advisor']),
        'showImageNetwork': !exists(json, 'showImageNetwork') ? undefined : json['showImageNetwork'],
        'jobProfilePublicState': !exists(json, 'JobProfilePublicState') ? undefined : json['JobProfilePublicState'],
        'jobTypes': !exists(json, 'JobTypes') ? undefined : ((json['JobTypes'] as Array<any>).map(SimpleTextResultFromJSON)),
        'workExperience': !exists(json, 'WorkExperience') ? undefined : ((json['WorkExperience'] as Array<any>).map(WorkExperienceFromJSON)),
        'education': !exists(json, 'Education') ? undefined : ((json['Education'] as Array<any>).map(EducationExperienceFromJSON)),
        'courses': !exists(json, 'Courses') ? undefined : ((json['Courses'] as Array<any>).map(CourseExperienceFromJSON)),
        'volunteerExperience': !exists(json, 'VolunteerExperience') ? undefined : ((json['VolunteerExperience'] as Array<any>).map(VolunteerExperienceFromJSON)),
    };
}

export function PublicProfileToJSON(value?: PublicProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Email': value.email,
        'Name': value.name,
        'Zip': value.zip,
        'City': value.city,
        'Country': value.country,
        'Linkedin': value.linkedin,
        'showImage': value.showImage,
        'Resume': value.resume,
        'Header': value.header,
        'PersonalProfile': value.personalProfile,
        'educationLevelText': value.educationLevelText,
        'ExternalLinks': value.externalLinks === undefined ? undefined : ((value.externalLinks as Array<any>).map(ExternalLinkToJSON)),
        'Competences': value.competences === undefined ? undefined : ((value.competences as Array<any>).map(SimpleTextResultToJSON)),
        'personalCompetences': value.personalCompetences === undefined ? undefined : ((value.personalCompetences as Array<any>).map(PersonalCompetenceItemSimpleToJSON)),
        'JobGoals': value.jobGoals === undefined ? undefined : ((value.jobGoals as Array<any>).map(SimpleTextResultToJSON)),
        'JobFunctions': value.jobFunctions === undefined ? undefined : ((value.jobFunctions as Array<any>).map(SimpleTextResultToJSON)),
        'Mobility': MobilityTypeToJSON(value.mobility),
        'Languages': value.languages === undefined ? undefined : ((value.languages as Array<any>).map(SelectedItemToJSON)),
        'ItCompetences': value.itCompetences === undefined ? undefined : ((value.itCompetences as Array<any>).map(SelectedItemToJSON)),
        'DriverLicenses': value.driverLicenses === undefined ? undefined : ((value.driverLicenses as Array<any>).map(ItemToJSON)),
        'managementExperience': ManagementExperienceTextToJSON(value.managementExperience),
        'Phone': value.phone,
        'Mobile': value.mobile,
        'Advisor': AdvisorToJSON(value.advisor),
        'showImageNetwork': value.showImageNetwork,
        'JobProfilePublicState': value.jobProfilePublicState,
        'JobTypes': value.jobTypes === undefined ? undefined : ((value.jobTypes as Array<any>).map(SimpleTextResultToJSON)),
        'WorkExperience': value.workExperience === undefined ? undefined : ((value.workExperience as Array<any>).map(WorkExperienceToJSON)),
        'Education': value.education === undefined ? undefined : ((value.education as Array<any>).map(EducationExperienceToJSON)),
        'Courses': value.courses === undefined ? undefined : ((value.courses as Array<any>).map(CourseExperienceToJSON)),
        'VolunteerExperience': value.volunteerExperience === undefined ? undefined : ((value.volunteerExperience as Array<any>).map(VolunteerExperienceToJSON)),
    };
}

